import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class CardComponent {
  @Input() isHighlighted = false;
  @Input() public isRadioSelect = false;

  @Output() selected = new EventEmitter<void>();

  public handleClick(): void {
    this.selected.emit();
  }
}
